import React from 'react';
import { IRoute } from 'types';
import {
  COMMON_ROLES,
  CUSTOMER_CARE_ROLES,
  OFFICE_HEAD_ROLES,
  ADMIN_ROLES,
} from '../constants/roles';
import MultiTransactions from '@pages/multi-transaction-download/MultiTransactionDownload';

const Transactions = React.lazy(
  () => import('@pages/transactions/Transactions'),
);
const VouchersReport = React.lazy(
  () => import('@pages/redeem-voucher/VouchersReport'),
);
const Success = React.lazy(() => import('@pages/success/Success'));
const RedeemVoucher = React.lazy(() => import('@pages/redeem-voucher/index'));
const ScanBoardingPass = React.lazy(
  () => import('@pages/redeem-voucher/scan-boarding-pass'),
);
const ClientDashboard = React.lazy(() => import('@pages/navbar/Clients'));
const DashboardLounges = React.lazy(() => import('@pages/navbar/Lounges'));
const DevicesDashboard = React.lazy(() => import('@pages/navbar/Devices'));
const CardCategoryDashboard = React.lazy(
  () => import('@pages/navbar/CardCategory'),
);
const BinSearchDashboard = React.lazy(() => import('@pages/navbar/BinSearch'));
const EligibilityAttempts = React.lazy(
  () => import('@pages/navbar/EligibilityAttempts'),
);
const BookingHistoryPage = React.lazy(
  () => import('@pages/BookingHistoryPage'),
);
const DashboardUsers = React.lazy(() => import('@pages/navbar/Users'));

export const routes: IRoute[] = [
  {
    path: '/transactions',
    key: 'transactions',
    element: <Transactions />,
    rolesAllowed: COMMON_ROLES,
  },
  {
    path: '/voucher-report',
    key: 'voucher',
    element: <VouchersReport />,
    rolesAllowed: COMMON_ROLES,
  },
  {
    path: '/success',
    key: 'success',
    element: <Success />,
    rolesAllowed: COMMON_ROLES,
  },
  {
    path: '/redeem-voucher',
    key: 'redeem-voucher',
    element: <RedeemVoucher />,
    rolesAllowed: COMMON_ROLES,
  },
  {
    path: '/scan-boarding-pass',
    key: 'scan-boarding-pass',
    element: <ScanBoardingPass />,
    rolesAllowed: COMMON_ROLES,
  },
  {
    path: '/client',
    key: 'client',
    element: <ClientDashboard />,
    rolesAllowed: OFFICE_HEAD_ROLES,
  },
  {
    path: '/lounges',
    key: 'lounges',
    element: <DashboardLounges />,
    rolesAllowed: OFFICE_HEAD_ROLES,
  },
  {
    path: '/devices',
    key: 'devices',
    element: <DevicesDashboard />,
    rolesAllowed: OFFICE_HEAD_ROLES,
  },
  {
    path: '/devices',
    key: 'devices',
    element: <DevicesDashboard />,
    rolesAllowed: OFFICE_HEAD_ROLES,
  },
  {
    path: '/card-category',
    key: 'card-category',
    element: <CardCategoryDashboard />,
    rolesAllowed: OFFICE_HEAD_ROLES,
  },
  {
    path: '/bin-search',
    key: 'bin-search',
    element: <BinSearchDashboard />,
    rolesAllowed: OFFICE_HEAD_ROLES,
  },
  {
    path: '/eligibility-attempts',
    key: 'eligibility-attempts',
    element: <EligibilityAttempts />,
    rolesAllowed: [...OFFICE_HEAD_ROLES, ...CUSTOMER_CARE_ROLES],
  },
  {
    path: '/eligibility-attempts/bookings/:attemptId',
    key: 'eligibility-attempts-bookings',
    element: <BookingHistoryPage />,
    rolesAllowed: [...OFFICE_HEAD_ROLES, ...CUSTOMER_CARE_ROLES],
  },
  {
    path: '/reports',
    key: 'reports',
    element: <MultiTransactions />,
    rolesAllowed: OFFICE_HEAD_ROLES,
  },
  {
    path: '/users',
    key: 'users',
    element: <DashboardUsers />,
    rolesAllowed: ADMIN_ROLES,
  },
];
